<template>
  <form v-if="isLoaded" @submit.prevent="submitForm" novalidate
        client-dropdown=""
        sub-client-id=""
        report-sick-days-id=""
        user-dropdown=""
        submit-form
        reported-sick-days-id="">
    <div class="row">
      <div class="col-lg-5 col-md-8 col-sm-12">
        <SelectVue
            v-model="formData.userId"
            :options="userDropdown"
            :is-clear="true"
            :label="$t('general.employee')"
            :placeholder="$t('general.employee')"
            :validation="v$.userId"
            :messages="v$.userId.required.$message"/>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <Datepicker
            v-model="formData.startDate"
            position="down"
            :label="$t('general.start_date')"
            :placeholder="$t('general.start_date')"
            :validation="v$.startDate"
            :messages="v$.startDate.required.$message"/>
      </div>
      <div class="col-lg-2 col-md-6 col-sm-12">
        <Datepicker
            v-model="formData.endDate"
            position="down"
            :label="$t('general.end_date')"
            :placeholder="$t('general.end_date')"
            :validation="v$.endDate"
            :messages="v$.endDate.required.$message"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <span>eAU</span>
        <div class="row">
          <BaseRadio
              v-model="formData.eAu"
              label="Ja"
              name="eAu"
              id="1"
              :labelPosition="'right'"
              classFormGroup="col-auto"/>

          <BaseRadio
              v-model="formData.eAu"
              label="Nein"
              name="eAu"
              id="0"
              :labelPosition="'right'"
              classFormGroup="col-auto"/>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center w-100 mt-3">
      <button class="btn btn-primary" type="submit">{{ $t('general.button.save') }}</button>
    </div>
  </form>
</template>

<script setup>
import reportSickDaysService from '@/api/ReportSickDays';
import BaseRadio from '@/components/base/BaseRadio.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import { requiredRule } from '@/shared/validators/validationRules';
import useVuelidate from '@vuelidate/core';
import { computed, defineEmits, defineProps, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t }        = useI18n();
const isLoaded     = ref(false);
const isSubmitting = ref(false);
const emit         = defineEmits([ 'update:modelValue', 'update:submitForm' ]);

const props = defineProps({
  userDropdown: {
    type: Array,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const formData = ref({
  name: '',
  userId: '',
  startDate: '',
  endDate: '',
  eAu: '0',
});

const rules = computed(() => {
  return {
    userId: requiredRule(t),
    startDate: requiredRule(t),
    endDate: requiredRule(t),
    eAu: requiredRule(t),
  };
});

const v$ = useVuelidate(rules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.eAu = +formData.value.eAu;

    await reportSickDaysService.postSickDays(formData.value);

    emit('update:modelValue', false);
    emit('update:submitForm', !props.submitForm);

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

onMounted(async () => {
  isLoaded.value = true;
});
</script>
<style scoped>

</style>